type iconProps = {
  fill?: string
  secondaryfill?: string
  strokewidth?: number
  width?: string
  height?: string
  title?: string
}

function SquareArrowUp(props: iconProps) {
  const fill = props.fill || 'currentColor'
  // const secondaryfill = props.secondaryfill || fill
  const title = props.title || 'square arrow up'
  const width = props.width || 24
  const height = props.height || 24
  const strokewidth = props.strokewidth || 2

  return (
    <svg
      height={height}
      width={width}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <g
        fill='#0e1647'
        strokeLinecap='square'
        strokeLinejoin='miter'
        strokeMiterlimit='10'
      >
        <path
          d='M10 43H38C40.7614 43 43 40.7614 43 38V10C43 7.23858 40.7614 5 38 5H10C7.23858 5 5 7.23858 5 10V38C5 40.7614 7.23858 43 10 43Z'
          fill='none'
          stroke={fill === 'white' ? '#ffffff' : '#0e1647'}
          strokeWidth={strokewidth}
        />
        <path
          d='M24 36L24 12V12.5'
          fill='none'
          stroke={fill === 'white' ? '#ffffff' : '#0e1647'}
          strokeWidth={strokewidth}
        />
        <path
          d='M13 23L24 12L35 23'
          fill='none'
          stroke={fill === 'white' ? '#ffffff' : '#0e1647'}
          strokeWidth={strokewidth}
        />
      </g>
    </svg>
  )
}

export default SquareArrowUp
